module.exports = __webpack_public_path__ + "img/he_seating.040eb5a4.png";